"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getResourceUrl = getResourceUrl;
exports.setBaseUrl = setBaseUrl;
var _baseUrl = '';
/**
 * @deprecated Unused as of version 8
 */
function getResourceUrl(url) {
    return _baseUrl + url;
}
/**
 * @deprecated Unused as of version 8
 */
function setBaseUrl(baseUrl) {
    _baseUrl = baseUrl;
}
//# sourceMappingURL=resources.js.map